<div class="dialog-container" [@openState]="state">
  <div class="dialog dialog-wide">
    <div class="heading">
      <h2>
        Ajouter une nouvelle entité
        <span *ngIf="mode === 'step-2'">/ Champs supplémentaires</span>
      </h2>
      <t-icon name="close" class="close" (click)="close()" title="Fermer"></t-icon>
    </div>
    <div class="content content-form">

      <!-- STEP 1 -->
      <ng-container *ngIf="mode === 'step-1'">

        <sl-entity-form [entity]="entity"></sl-entity-form>
        
        <div class="buttons">
          <button class="btn btn-small btn-primary" [disabled]="!entity.valid" (click)="showStep('step-2', $event)">
            <t-icon name="arrow_forward"></t-icon>
            <span class="text">Suivant</span>
          </button>

          <button class="btn btn-small btn-gray" (click)="close()">
            <t-icon name="close"></t-icon>
            <span class="text">Annuler</span>
          </button>
        </div>

      </ng-container>

      <!-- STEP 2 -->
      <ng-container *ngIf="mode === 'step-2'">

        <sl-entity-extra-fields-form [entity]="entity"  [dossierModel]="dossierModel" [inline]="true"></sl-entity-extra-fields-form>

        <div class="buttons">

          <button class="btn btn-small btn-primary" [disabled]="!entity.valid || saving" (click)="submit()">
            <t-icon name="check"></t-icon>
            <span class="text">Enregister</span>
          </button>

          <button class="btn btn-small btn-gray" (click)="showStep('step-1', $event)">
            <t-icon name="arrow_back"></t-icon>
            <span class="text">Précédent</span>
          </button>

          <button class="btn btn-small btn-gray" (click)="close()">
            <t-icon name="close"></t-icon>
            <span class="text">Annuler</span>
          </button>
        </div>

      </ng-container>

    </div>
  </div>
</div>